import { useQuery } from '@tanstack/react-query';

import { getMemberDataExports } from 'apps-common/graphql/getMemberDataExports';
import { MemberDataExport } from 'apps-common/types';

export const useGetMemberDataExports = (isAutoFetch = true) =>
  useQuery<{
    exports: MemberDataExport[];
    canInitiateNewExport: boolean;
  }>({
    queryKey: ['getMemberDataExports'],
    queryFn: async () => {
      const { memberDataExports } = await getMemberDataExports();
      const { canInitiateNewExport = true, exports = [] } = memberDataExports;
      return {
        exports,
        canInitiateNewExport,
      };
    },
    retry: false,
    staleTime: 1000 * 60, // 1 minute
    enabled: isAutoFetch,
    refetchOnWindowFocus: false,
  });
